import globals from './globals';
import financeEstimator from './financeEstimator';

const configurator = {
  __typename: 'Configurator',
  globals,
  financeEstimator
};

export default configurator;
